import {
  authenticate,
  loginBySso
} from "@/api/auth";
import {
  setAdditionalFields,
  setUser
} from "@/store/user/user";
import { getStore } from '@/store/storeRegistry';
import { isStatusError } from '@/api/interfaces';
import { IInitUser } from '@/store/user/interfaces'
import camelcaseKeys from 'camelcase-keys'

export const auth = async () => {
  const store = getStore()
  const state = store.getState()
  const user = state.user.user
  if (!user?.memberId || !user.accessToken) {
    throw new Error('User not found')
  }
  let token = user.accessToken
  let dataUser
  if (user.sso) {
    try {
      dataUser = await loginBySso({
        memberId: user.memberId,
        otp: token
      })
      if (isStatusError(dataUser)) {
        throw new Error(dataUser.error.message)
      }
      token = dataUser.accessToken
      store.dispatch(setAdditionalFields({
        ...dataUser,
        sso: false
      }))
    } catch (e) {
      store.dispatch(setUser(null))
      return
    }
  }
  const userInfo = await authenticate({
    memberId: user.memberId,
    accessToken: token
  })
  store.dispatch(setAdditionalFields(userInfo))
}


export const uncodeSubscription = (data: string): IInitUser['subscribe'] | undefined => {
  try {
    return camelcaseKeys(JSON.parse(atob(data)), {deep: true})
  } catch (e) {
    return undefined
  }
}
